// extracted by mini-css-extract-plugin
export default {"container":"styles__container___52uiw","icon":"styles__icon___3uMRC","title":"styles__title___HUWj0"};